function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIheartradioLogoFullcolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.26 61.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.27,0c3.49,0,6.37,2.88,6.37,6.37s-2.88,6.37-6.37,6.37-6.37-2.88-6.37-6.37,2.88-6.37,6.37-6.37ZM101.65,16v43.91h-10.77V16h10.77Z",
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.93,59.91v-23.74h-23.13v23.74h-10.77V3.03h10.77v23.59h23.13V3.03h10.77v56.88h-10.77Z",
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.35,42.7h-35.42c1.14,4.85,6.14,9.18,12.29,9.18,4.55,0,8.11-2.43,9.86-5.16h11.68c-3.11,8.87-11.75,14.48-21.54,14.48-13.12,0-23.81-10.01-23.81-23.28s10.77-23.21,23.96-23.21,23.59,10.24,23.59,23.21c0,1.67-.23,3.11-.61,4.78ZM191.43,33.67c-1.06-5.31-5.46-9.86-12.06-9.86s-11.22,4.55-12.29,9.86h24.34Z",
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52,52.86h-.15c-2.43,4.1-7.28,8.34-14.64,8.34-12.82,0-23.28-9.93-23.28-23.28s10.47-23.21,23.28-23.21c6.9,0,11.6,3.56,14.64,7.66h.15v-6.37h10.77v43.91h-10.77v-7.05ZM230.09,24.42c-7.43,0-13.42,6.14-13.42,13.5s5.99,13.58,13.42,13.58,13.42-6.14,13.42-13.58-5.92-13.5-13.42-13.5Z",
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2,16h10.77v6.07h.15c2.28-3.87,5.54-7.36,11.15-7.36h1.06v10.92h-2.66c-5.16,0-9.33,4.02-9.71,9.1v25.18h-10.77V16Z",
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.04,24.65v-8.65h3.94V6.07h10.77v9.93h7.51v8.65h-7.51v23.06c0,1.52,1.22,2.66,2.58,2.66h4.93v9.55h-4.93c-7.89,0-13.35-5-13.35-12.97v-22.3h-3.94Z",
    style: {
      fill: "#101820"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    "data-name": "Heart BUG",
    d: "M58.96,0c-7.65,0-14.49,4.05-18.45,9.97C36.56,4.05,29.72,0,22.07,0,9.88,0,0,9.88,0,22.07c0,7.73,4.9,13.31,10.02,18.47l20.01,18.92c1.05.99,2.77.25,2.77-1.19v-14.74c0-4.26,3.45-7.72,7.72-7.73,4.26,0,7.72,3.46,7.72,7.73v14.74c0,1.44,1.73,2.19,2.77,1.19l20.01-18.92c5.12-5.16,10.02-10.74,10.02-18.47,0-12.19-9.88-22.07-22.07-22.07ZM20.48,39.09c-.3.34-.72.51-1.14.51-.36,0-.72-.13-1.01-.38-6.59-5.84-9.93-11.94-9.93-18.12v-.07c0-5.31,3.24-11.36,7.54-14.05.72-.45,1.66-.23,2.11.48.45.71.23,1.66-.48,2.11-3.43,2.15-6.11,7.18-6.11,11.46v.07c0,5.27,3,10.6,8.9,15.83.63.56.69,1.53.13,2.16ZM30.32,33.41c-.28.5-.8.78-1.34.78-.25,0-.51-.06-.75-.19-4.47-2.5-7.48-7.42-7.5-12.24v-.05c.02-4.59,2.55-8.76,6.61-10.9.75-.39,1.67-.11,2.07.64.39.75.11,1.67-.64,2.07-3.06,1.61-4.97,4.76-4.98,8.21,0,3.76,2.39,7.61,5.93,9.6.74.41,1,1.34.59,2.08ZM40.52,29.51c-3.66,0-6.63-2.97-6.63-6.64s2.97-6.64,6.63-6.64c3.66,0,6.63,2.97,6.63,6.64s-2.97,6.64-6.63,6.64ZM52.79,34c-.24.13-.49.19-.75.19-.54,0-1.05-.28-1.34-.78-.41-.74-.15-1.67.59-2.08,3.54-1.98,5.92-5.84,5.93-9.6,0-3.46-1.91-6.6-4.98-8.21-.75-.39-1.04-1.32-.64-2.07.39-.75,1.32-1.03,2.07-.64,4.07,2.14,6.59,6.31,6.61,10.9v.05c-.02,4.82-3.03,9.74-7.5,12.24ZM72.64,21.1c0,6.18-3.34,12.28-9.93,18.12-.29.26-.65.38-1.01.38-.42,0-.84-.17-1.14-.51-.56-.63-.5-1.6.13-2.16,5.91-5.23,8.9-10.56,8.9-15.83v-.07c0-4.28-2.68-9.31-6.11-11.46-.72-.45-.93-1.39-.48-2.11.45-.72,1.39-.93,2.11-.48,4.3,2.7,7.54,8.74,7.54,14.05v.07Z",
    style: {
      fill: "#c6002b"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIheartradioLogoFullcolor);
export default __webpack_public_path__ + "static/media/iheartradio-logo-fullcolor.198e7d340acd05f6297b6552a178f564.svg";
export { ForwardRef as ReactComponent };